<div class="MainBg">
    <div class="NewHeadOuter">
        <div>
            <div class="SectionTopHeading_n">Bank Covering Letter</div>
            <div class="SubHeader"></div>
        </div>
        <!-- <a class="RightSideLink" routerLinkActive="active"><i class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Back </a> -->

    </div>
    <div class="MainInnerFormWithoutFlex">
      <div class="FormTemplate pb-0">
        <div class="row">
          <div  class="col-lg-3 col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
            <div class="has-float-label">
              <select
                class="form-control CommonSelectBox TbxMarginBtm CustomSelectCompany"
                id="CompanyId"
              >
                <option value="">Select Company</option>
                <option
                  *ngFor="let item of CompanyList"
                  value="{{ item.VALUEFIELD }}"
                >
                {{item.TEXTFIELD}}
                </option>
              </select>
              <label>Company Name</label>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 InputBoxOuter" >
            <div class="has-float-label">
              <input
                type="text"
                class="form-control CommonTextBox TbxMarginBtm"
                id="ApplicationNo"
                placeholder="&nbsp;"
              />
              <label for="ApplicationNo">Application No</label>

            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-3 col-xs-12 InputBoxOuter">
            <button id="download" class="CommonSubmitButton" (click)="BindBankCoveringList('0','ApplicationNo')">Search</button>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
            <button id="download" class="CommonSubmitButton" (click)="downloadcoveringletter('0','New')">Download Bank Covering
              Letter</button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-12  mb-3">
        <button class="btn btn-primary" id="download"> Download PDF</button>
    </div> -->
    <!-- <div class="SubmitMarginTop ml-3">

    </div> -->

    <!-- code for pdf  -->
    <div class="MainInnerFormWithoutFlex border-none">
        <div class="row">
            <div class="col-md-12" id="BankCoveringDiv">
                <!-- <div class="card" id="invoice" #invoice>
                    <div class=" card-header bg-transparent header-elements-inline">
                        <p class="card-title  d-flex justify-content-center"><u>ASBA Bank Covering Letter</u></p>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6 d-flex align-items-end">
                                <div class="mb-4 pull-left">
                                    <p>Branch:- <span class="font-weight-semibold">{{BranchName}}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-sm-6 d-flex align-items-center justify-content-end">
                                <div class="mb-4 pull-left">
                                    <img _ngcontent-ntn-c136="" src="../assets/images/IIFL_Logo_reports.png" alt="Logo">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-9 text-left">
                                <p>To,<br> <span class="font-weight-semibold">{{BankName}}</span>
                                </p>
                            </div>
                            <div class="col-sm-3 text-right">
                                <div class="mb-4 pull-left">
                                    <p>Date:- <span class="font-weight-semibold">{{today | date:'dd-MM-yyyy'}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 text-center d-flex justify-content-center">
                                <div class="mb-4 pull-left">
                                    <p><span class="font-weight-semibold"><b>Sub: Delivery of ASBA - Bidded applications for blocking of funds in Investor's Bank account</b></span>
                                        <br>
                                        <span class="font-weight-semibold"><b>Issue Name : {{CompanyName}}</b></span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 text-left">
                                <p class="w-90"><span class="font-weight-semibold"><b>Please find attached herewith the
                                            annexure with details of applications bidded on Stock Exchange in the above
                                            Public issue.</b></span>
                                    <br>
                                    <span class="font-weight-semibold"><b>You are requested to acknowledge the receipt
                                            and block the funds in the Investor
                                            bank account</b></span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="d-md-flex flex-md-wrap">
                            <div class="col-md-2"></div>
                            <div class="col-md-9 d-flex justify-content-end">
                                <div class="pt-2 mb-3 wmin-md-400 ml-auto text-right">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-sm">
                                            <tbody>
                                                <tr>
                                                    <td class="text-left pb-0">
                                                        <p class="mb-3 text-left font-20">Total Count of Applications</p>
                                                    </td>
                                                    <td class="text-right">
                                                        <p class="font-20"> <b>Rs. {{TotalApplicationCount}} </b></p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-left pb-0">
                                                        <p class="mb-3 text-left font-20">Total Amount</p>
                                                    </td>
                                                    <td class="text-right">
                                                        <p class="font-20"> <b> {{TotalApplicationAmount}} </b></p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-left pb-0">
                                                        <p class="mb-3 text-left font-20">Received  by (Bank Seal) & Date Amount</p>
                                                    </td>
                                                    <td class="text-right">
                                                        <p class="font-20"> <b>  </b></p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-1"></div>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="table-responsive">
                            <p class="font-20 text-left"> <b> <i> SEBI Annexure :</i> </b></p>
                            <font size="10">
                                <table id="dataTable_tally_sheet_pdf" class="CommonTable ClsReportTable nowrap table-lg"
                                    width="100%">
                                    <thead>
                                        <tr>
                                            <th>Sr No.</th>
                                            <th>Symbol</th>

                                            <th colspan="3">Intermediary Name</th>

                                            <th>Application No.</th>
                                            <th colspan="3">Client ID/Client Name</th>
                                            <th>PAN</th>
                                            <th>Bank Code</th>
                                            <th>Bank Name</th>
                                            <th class="text-right">Qty</th>
                                            <th class="text-right">Price</th>
                                            <th class="text-right">Amount</th>
                                            <th class="text-right">Series</th>
                                            <th class="text-right">Sub Category</th>

                                            <th class="text-right">Order No.</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of bankcovering;let i = index">
                                            <td>{{i+1}}</td>
                                            <td>{{data.Scrip_ID}}</td>

                                            <td colspan="3">{{data.Company_Name}}</td>

                                            <td>{{data.ApplicationNo}}</td>
                                            <td colspan="3">{{data.ClientDematId}}</td>
                                            <td>{{data.PAN}}</td>
                                            <td>{{data.BankCode}}</td>
                                            <td>{{data.BankName}}</td>
                                            <td class="text-right">{{data.Quantity}}</td>
                                            <td class="text-right">{{data.Price}}</td>
                                            <td class="text-right">{{data.Amount}}</td>
                                            <td class="text-right">{{data.Series}}</td>
                                            <td class="text-right">{{data.Category}}</td>

                                            <td class="text-right">{{data.BidId}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </font>
                        </div>
                    </div>


                </div> -->


                <div #htmlContent id="htmlContent">

                </div>
            </div>
        </div>
    </div>

    <!-- table start-->
    <div id="TblReportSection" class="MainInnerFormWithoutFlex">
        <div class="tab-content DotTabsContent">
            <div class="tab-pane active show">
                <div class="table-responsive table-container">
                    <table id="dataTable_tally_sheet" style="font-size:14px;" class="CommonTable ClsReportTable nowrap" width="100%">
                        <thead style="font-size:14px;">
                            <tr>
                                <th class="table-font">Sr No.</th>
                                <th class="table-font">File Name</th>
                                <th class="table-font">Generated Date</th>
                                <th class="text-right table-font">Download ZIP</th>
                            </tr>
                        </thead>
                        <tbody style="font-size:14px;">
                            <tr *ngFor="let item of bankcoveringList; let i= index">
                              <td class="table-font">{{i+1}}</td>
                              <td class="table-font">{{item.FileName}}</td>
                              <td class="table-font">{{item.GeneratedDate}}</td>
                                <td>
                                    <span class="d-flex justify-content-end">
                                        <button class="BtnCommon BtnRed BtnExport ml-2 text-right"
                                            (click)="downloadcoveringletter(item.LotNo,'ByLotNo')">
                                            <img src="../../assets/images/PDF_Export.svg" class="ExportToIcon"
                                                type="image/svg+xml" fill="#fff" width="12px"
                                                pluginspage="http://www.adobe.com/svg/viewer/install/" /></button>
                                    </span>
                                </td>

                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- Holding Summary end-->
</div>


